import { render, staticRenderFns } from "./block-categories.vue?vue&type=template&id=45e24bf0"
import script from "./block-categories.vue?vue&type=script&lang=js"
export * from "./block-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports